import React from 'react';
import { trackInitiateCheckout } from './MetaPixel';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  isFinal?: boolean;
}
export function Button({
  children,
  className = '',
  isFinal = false
}: ButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    if (isFinal) {
      trackInitiateCheckout();
      window.location.href = 'https://checkout.sectordigital.online/cart/44063671025707:1';
    } else {
      e.preventDefault();
      const target = document.getElementById('comprar');
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  };
  return <button onClick={handleClick} className={`group relative inline-flex items-center justify-center gap-2 rounded-xl bg-emerald-500 px-8 py-5 text-lg font-bold text-white shadow-[0_8px_0_0_#047857] transition-all hover:-translate-y-1 hover:bg-emerald-400 hover:shadow-[0_12px_0_0_#047857] active:translate-y-2 active:shadow-[0_0px_0_0_#047857] sm:text-xl w-full sm:w-auto ${className}`} data-id="element-81">
      {children}
    </button>;
}